export default {};


//////////////////
// WEBPACK FOOTER
// ./src/vuex/actions.js
// module id = 904
// module chunks = 2